import { ResponsiveBar } from "@nivo/bar";
import { CustomChartTooltip } from "common/components/Etc/tooltip";
import { colors } from "common/const/colors";
import { barChartTheme } from "./ChartTheme";

export const BarChart = ({ data }) => {
  const parsedData = data;

  const generateTickValues = (data) => {
    let maxValue = 0;
    data.forEach((data) => {
      if (data.value > maxValue) maxValue = data.value;
    });

    if (maxValue === 0) return [0];

    const digits = Math.floor(Math.log10(maxValue)) + 1;
    let step;

    if (digits <= 3) {
      // 자리수 적을 때 (1~999)
      const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)) - 1);
      step = Math.max(1, magnitude * 5);
    } else {
      // 자리수 많을 때 (1000+)
      const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
      step = Math.max(1, magnitude);
    }

    const roundedMaxY = Math.ceil(maxValue / step) * step;
    const tickValues = [];
    for (let i = 0; i <= roundedMaxY; i += step) {
      tickValues.push(i);
    }
    return tickValues;
  };

  const tickValues = generateTickValues(data);
  const leftMargin =
    Math.floor(Math.log10(tickValues.at(-1) || 1) + 1) * 10 + 8;

  const getBarColor = (bar) => {
    const index = bar.index;
    const colorIndex = index % colors.BlueScale.length;
    if (
      colorIndex === 0 &&
      index > colors.BlueScale.length - 1 &&
      index === data.length - 1
    )
      return colors.BlueScale[1];

    return colors.BlueScale[colorIndex];
  };

  return (
    <ResponsiveBar /* or Bar for fixed dimensions */
      data={parsedData}
      indexBy="key"
      groupMode="grouped"
      padding={0.2}
      borderRadius={2}
      yScale={{
        type: "linear",
        min: 0,
        max: tickValues.at(-1),
        stacked: false,
        reverse: false,
      }}
      axisLeft={{
        tickValues: tickValues,
        tickSize: 0,
        tickPadding: 8,
        tickRotation: 0,
      }}
      axisBottom={{
        orient: "bottom",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        style: {
          ticks: {
            text: { fontSize: 12, fontWeight: 600, color: colors.DarkNavy },
          },
        },
      }}
      enableGridX={false}
      enableGridY={false}
      enableLabel={false}
      colors={(bar) => getBarColor(bar)}
      animate={false}
      theme={barChartTheme}
      tooltip={CustomChartTooltip}
      margin={{ top: 25, right: 0, bottom: 50, left: leftMargin }}
      layers={[
        "grid",
        "markers",
        (props) => <CustomHorizontalLines {...props} lineValues={tickValues} />,
        "axes",
        "bars",
      ]}
    />
  );
};

const CustomHorizontalLines = ({ yScale, width, lineValues }) => {
  return (
    <>
      {lineValues.map((value) => {
        const isFirst = value === 0;
        return (
          <line
            key={`grid-line-${value}`}
            y1={yScale(value)}
            y2={yScale(value)}
            x1={0}
            x2={width}
            stroke={isFirst ? colors.Black : colors.Gray}
            strokeWidth={1}
          />
        );
      })}
    </>
  );
};
